import React from "react";
import { HOURS, STATUS_BAR, STATUS_STYLE, addDays, dayKey, hm, minutesFromStart } from "./calendarUtils";

const PX_PER_MIN = 1.1; // 66px per uur
const dayLabel = (d, locale) => d.toLocaleDateString(locale, { weekday: "short", day: "2-digit", month: "short" });

/* Week- (7 kolommen) of dagweergave (1 kolom, gesplitst per monteur als er monteurs zijn) */
export const WeekView = ({ start, days, apptByDay, mechanics, onOpen, onNew, onDrop, t, meta }) => {
  const cols = days === 1 && mechanics.length > 0
    ? [{ key: "none", label: t("unassigned"), d: start, mech: "" }, ...mechanics.map((m) => ({ key: m.id, label: m.name, d: start, mech: m.id }))]
    : Array.from({ length: days }, (_, i) => { const d = addDays(start, i); return { key: dayKey(d.toISOString()), label: dayLabel(d, meta.locale), d, mech: null }; });
  const todayKey = dayKey(new Date().toISOString());
  const nowMin = minutesFromStart(new Date().toISOString());
  const dropAt = (e, col) => {
    e.preventDefault();
    const rect = e.currentTarget.getBoundingClientRect();
    const mins = Math.max(0, Math.round((e.clientY - rect.top) / PX_PER_MIN / 15) * 15);
    const d = new Date(col.d); d.setHours(HOURS[0], 0, 0, 0); d.setMinutes(mins);
    return d;
  };
  return (
    <div className="overflow-x-auto" data-testid={days === 1 ? "cal-day-view" : "cal-week-view"}>
      <div className="grid min-w-[640px]" style={{ gridTemplateColumns: `52px repeat(${cols.length}, minmax(0,1fr))` }}>
        <div />
        {cols.map((c) => (
          <div key={c.key} className={`text-center py-2 border-b border-border text-xs font-semibold ${c.key === todayKey ? "text-primary" : ""}`} data-testid={`cal-col-${c.key}`}>{c.label}</div>
        ))}
        <div className="relative" style={{ height: HOURS.length * 60 * PX_PER_MIN }}>
          {HOURS.map((h) => <div key={h} className="absolute right-2 -translate-y-1/2 text-[10px] font-mono text-muted-foreground" style={{ top: (h - HOURS[0]) * 60 * PX_PER_MIN }}>{String(h).padStart(2, "0")}:00</div>)}
        </div>
        {cols.map((c) => {
          const k = dayKey(c.d.toISOString());
          let items = apptByDay[k] || [];
          if (c.mech !== null) items = items.filter((a) => (a.mechanic_id || "") === c.mech);
          return (
            <div key={c.key} className="relative border-l border-border/60" style={{ height: HOURS.length * 60 * PX_PER_MIN }}
                 onDragOver={(e) => e.preventDefault()}
                 onDrop={(e) => { const id = e.dataTransfer.getData("text/appt"); if (id) onDrop(id, dropAt(e, c), c.mech); }}
                 onDoubleClick={(e) => onNew(dropAt(e, c), c.mech)} data-testid={`cal-slot-col-${c.key}`}>
              {HOURS.map((h) => <div key={h} className="absolute inset-x-0 border-t border-border/50" style={{ top: (h - HOURS[0]) * 60 * PX_PER_MIN }} />)}
              {k === todayKey && nowMin >= 0 && nowMin <= HOURS.length * 60 && <div className="absolute inset-x-0 h-[2px] bg-primary z-10" style={{ top: nowMin * PX_PER_MIN }} />}
              {items.map((a) => {
                const top = Math.max(0, minutesFromStart(a.scheduled_at) * PX_PER_MIN);
                const h = Math.max(26, (a.duration_min || 60) * PX_PER_MIN - 2);
                return (
                  <div key={a.id} draggable={a.status !== "completed" && a.status !== "cancelled"}
                       onDragStart={(e) => { e.dataTransfer.setData("text/appt", a.id); }}
                       onClick={(e) => { e.stopPropagation(); onOpen(a); }}
                       className={`absolute left-1 right-1 rounded-md border pl-2 pr-1 py-1 text-[11px] overflow-hidden cursor-pointer hover:shadow-md hover:z-20 ${STATUS_STYLE[a.status]}`}
                       style={{ top, height: h }} data-testid={`appt-block-${a.id}`}>
                    <span className={`absolute left-0 top-1 bottom-1 w-[3px] rounded-full ${STATUS_BAR[a.status]}`} />
                    <div className="font-semibold truncate"><span className="font-mono">{hm(a.scheduled_at)}</span> {a.customer_name || t("walkIn")}</div>
                    <div className="truncate opacity-80">{a.car_plate && <span className="font-mono">{a.car_plate} · </span>}{a.service_type}</div>
                    {h > 50 && a.mechanic_name && c.mech === null && <div className="truncate opacity-70">{a.mechanic_name}</div>}
                  </div>);
              })}
            </div>);
        })}
      </div>
    </div>
  );
};
